import { Moment } from 'moment';

export default class SyncResponse {
  synchronizationSuccessful = false;
  dataHasChanged = false;
  lastSynchronizedOn: Moment | null = null;
  lastSynchronizedBy: string | null = null;

  static create(
    synchronizationSuccessful: boolean,
    shouldRefresh: boolean,
    lastSynchronizedOn: Moment | null = null,
    lastSynchronizedBy: string | null = null,
  ): SyncResponse {
    const response = new SyncResponse();
    response.synchronizationSuccessful = synchronizationSuccessful;
    response.dataHasChanged = shouldRefresh;
    response.lastSynchronizedOn = lastSynchronizedOn;
    response.lastSynchronizedBy = lastSynchronizedBy;
    return response;
  }
}
